// A widget example: the working widget, then its code in the same frame.
.example {
  margin-block: 1.5rem;

  > :last-child {
    border-start-start-radius: 0;
    border-start-end-radius: 0;
  }
}

// A React Native example: its code, then the working widget below it in the same frame.
.exampleBelow {
  margin-block: 1.5rem;

  > :first-child {
    margin-block: 0;
    border-end-start-radius: 0;
    border-end-end-radius: 0;
  }
}

.frame {
  border: 1px solid var(--color-border);
  border-bottom: none;
  border-radius: var(--radius-lg) var(--radius-lg) 0 0;
  background: var(--color-card);
  padding: 1.25rem;

  &[data-placement="below"] {
    border-bottom: 1px solid var(--color-border);
    border-top: none;
    border-radius: 0 0 var(--radius-lg) var(--radius-lg);
  }

  // The loaded widget's height, so loading it doesn't move the page.
  &[data-widget="uploader"] {
    min-height: 15rem;
  }

  &[data-widget="media"] {
    min-height: 12rem;
  }
}

.content {
  display: grid;
  gap: 0.75rem;
}

// The React Native preview page, as tall as the page inside it reports.
.nativeFrame {
  display: block;
  width: 100%;
  height: 8rem;
  border: 0;
  background: transparent;
}

.media {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(9rem, 1fr));
  gap: 1rem;
}

.figure {
  display: grid;
  gap: 0.5rem;
  margin: 0;
  font-size: 0.875rem;
  text-align: center;

  :global(.calmlens-media) {
    border-radius: var(--radius-md);
  }
}
